import {
  PenToolIcon,
  PrinterIcon,
  StoreIcon,
  MonitorSmartphoneIcon,
} from 'lucide-react'
import type { DesignGroup } from '../types/content'

// Vier groepen, bewust ongeveer even groot gehouden (4, 5, 5, 6 onderdelen)
// zodat de kaarten op de pagina in evenwicht blijven.
export const designGroups: DesignGroup[] = [
  {
    id: 'merk',
    title: 'Merk',
    intro:
      'De basis waar al het andere op rust. Eén keer goed vastgelegd, daarna overal consequent toe te passen.',
    icon: PenToolIcon,
    items: [
      'Logo en huisstijl',
      'Huisstijlhandboek',
      'Favicon en app-iconen',
      'Iconensets',
    ],
  },
  {
    id: 'drukwerk',
    title: 'Drukwerk',
    intro:
      'Alles wat een klant in handen krijgt. Drukklaar aangeleverd, met de juiste maten en aflopen.',
    icon: PrinterIcon,
    items: [
      'Visitekaartjes',
      'Briefpapier',
      'Brochures',
      'Posters en flyers',
      'Menukaarten',
    ],
  },
  {
    id: 'groot-formaat',
    title: 'Groot formaat',
    intro:
      'Wat mensen van een afstand zien. Op de gevel, op de beursvloer of op de vloer van je zaak.',
    icon: StoreIcon,
    items: [
      'Gevelreclame',
      'Roll-up banners',
      'Beursmateriaal',
      'Productlabels',
      'Bedrijfskleding-ontwerp',
    ],
  },
  {
    id: 'digitaal',
    title: 'Digitaal',
    intro:
      'De sjablonen die je elke week gebruikt. Zo lijkt elk bericht en elk document van hetzelfde bedrijf te komen.',
    icon: MonitorSmartphoneIcon,
    items: [
      'E-mailfooters en handtekeningen',
      'Social media templates',
      'LinkedIn-banners',
      'Nieuwsbrief-templates',
      'Presentatiesjablonen',
      'Offerte- en factuursjablonen',
    ],
  },
]
